module.exports = __webpack_public_path__ + "img/edit_enhance_resolution.48bbddc.png";